import difference from 'lodash/difference';
import union from 'lodash/union';
import { useCallback, useMemo, useState } from 'react';
export function useSelectionTableWithInversion(options) {
    const { totalCount, results, getRowKey } = options;
    const [selectAllEnabled, setSelectAllEnabled] = useState(false);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const resetSelection = useCallback(() => {
        setSelectAllEnabled(false);
        setSelectedKeys([]);
    }, []);
    const pageSelectedKeys = useMemo(() => {
        var _a;
        const currentPageRowKeys = (_a = results === null || results === void 0 ? void 0 : results.map(getRowKey)) !== null && _a !== void 0 ? _a : [];
        const negativeSelection = difference(currentPageRowKeys, selectedKeys);
        return selectAllEnabled ? negativeSelection : selectedKeys;
    }, [results, getRowKey, selectAllEnabled, selectedKeys]);
    const selectAll = useCallback(() => {
        setSelectedKeys([]);
        setSelectAllEnabled(true);
    }, [setSelectAllEnabled, setSelectedKeys]);
    const selectedCount = useMemo(() => (selectAllEnabled ? (totalCount !== null && totalCount !== void 0 ? totalCount : 0) - selectedKeys.length : selectedKeys.length), [selectAllEnabled, totalCount, selectedKeys.length]);
    const updateSelection = useCallback((rowKeys, isSelected) => {
        const selected = isSelected !== null && isSelected !== void 0 ? isSelected : true;
        const doUnion = selected !== selectAllEnabled;
        const newSelectedRowKeys = doUnion ? union(selectedKeys, rowKeys) : difference(selectedKeys, rowKeys);
        if (selectAllEnabled && newSelectedRowKeys.length === totalCount) {
            resetSelection();
        }
        else {
            setSelectedKeys(newSelectedRowKeys);
        }
    }, [resetSelection, selectAllEnabled, selectedKeys, totalCount]);
    const handleTableRowSelect = useCallback((record, isSelected) => {
        updateSelection([getRowKey(record)], isSelected);
    }, [updateSelection, getRowKey]);
    const handleTablePageSelectAll = useCallback((selected, records) => {
        const pageRecords = results !== null && results !== void 0 ? results : [];
        const recordIds = records.filter(Boolean).map(getRowKey);
        const selection = selectAllEnabled && recordIds.length ? union(selectedKeys, recordIds) : pageRecords.map(getRowKey);
        updateSelection(selection, selected);
    }, [results, getRowKey, selectAllEnabled, selectedKeys, updateSelection]);
    return {
        handleTablePageSelectAll,
        handleTableRowSelect,
        pageSelectedKeys,
        resetSelection,
        selectAll,
        selectAllEnabled,
        selectedCount,
        selectedKeys,
        totalCount,
        updateSelection
    };
}
